export const MONTHS_ID = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
]

export const DAY_NAMES = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']

export const DEPARTMENT_TABS = [
  {
    id: 'digital-marketing',
    label: 'Digital Marketing',
    icon: '📱',
    color: '#22c55e',
    overview: {
      executive: '',
    },
    reports: [
      {
        id: 'wa-growth',
        label: 'WA Growth Metrics',
        title: 'REPORT 1) Whatsapp Growth Metrics Report',
      },
      {
        id: 'web-traffic',
        label: 'Web Traffic (30d)',
        title: 'REPORT 2) Web Traffic Report (30 Hari Terakhir)',
      },
      {
        id: 'web-traffic-utm',
        label: 'UTM Detailed (15d)',
        title: 'REPORT 3) Web Traffic Report - UTM Detailed (15 Hari Terakhir)',
      },
      {
        id: 'acquisition-funnel',
        label: 'Acquisition Funnel',
        title: 'REPORT 4) Customer Acquisition & Growth Funnel — Penjualan (30 Hari Terakhir)',
      },
      {
        id: 'top-landing',
        label: 'Top 30 Promo Pages',
        title: 'REPORT 5) Top 30 /promo/ Landing Pages (30 Hari Terakhir)',
      },
    ],
  },
  {
    id: 'sales',
    label: 'Sales',
    icon: '💰',
    color: '#f59e0b',
    overview: {
      executive: '',
    },
    reports: [
      {
        id: 'sales-daily', label: 'Daily Sales', title: 'Laporan Penjualan Harian',
      },
      {
        id: 'sales-pipeline', label: 'Pipeline', title: 'Sales Pipeline Report',
      },
      {
        id: 'sales-target', label: 'Target vs Actual', title: 'Target vs Realisasi Penjualan',
      },
    ],
  },
  {
    id: 'finance',
    label: 'Finance',
    icon: '📊',
    color: '#8b5cf6',
    overview: {
      executive: '',
    },
    reports: [
      {
        id: 'finance-daily', label: 'Daily Finance', title: 'Laporan Keuangan Harian',
      },
      {
        id: 'finance-cashflow', label: 'Cash Flow', title: 'Laporan Arus Kas',
      },
      {
        id: 'finance-ar-ap', label: 'AR/AP', title: 'Accounts Receivable / Payable',
      },
    ],
  },
  {
    id: 'manpower',
    label: 'Man Power',
    icon: '👥',
    color: '#3b82f6',
    overview: {
      executive: '',
    },
    reports: [
      {
        id: 'mp-attendance', label: 'Attendance', title: 'Laporan Kehadiran',
      },
      {
        id: 'mp-performance', label: 'Performance', title: 'Laporan Kinerja Karyawan',
      },
      {
        id: 'mp-overtime', label: 'Overtime', title: 'Laporan Lembur',
      },
    ],
  },
  {
    id: 'produksi',
    label: 'Produksi',
    icon: '🏭',
    color: '#ef4444',
    overview: {
      executive: '',
    },
    reports: [
      {
        id: 'prod-output', label: 'Daily Output', title: 'Laporan Output Produksi',
      },
      {
        id: 'prod-quality', label: 'Quality Control', title: 'Laporan QC',
      },
      {
        id: 'prod-downtime', label: 'Downtime', title: 'Laporan Downtime Mesin',
      },
    ],
  },
  {
    id: 'logistic',
    label: 'Logistic',
    icon: '🚚',
    color: '#06b6d4',
    overview: {
      executive: '',
    },
    reports: [
      {
        id: 'log-shipping', label: 'Shipping', title: 'Laporan Pengiriman',
      },
      {
        id: 'log-inventory', label: 'Inventory', title: 'Laporan Stok & Inventory',
      },
      {
        id: 'log-delivery', label: 'Delivery Rate', title: 'Laporan Tingkat Pengiriman',
      },
    ],
  },
  {
    id: 'accounting',
    label: 'Accounting',
    icon: '🧾',
    color: '#f97316',
    overview: {
      executive: '',
    },
    reports: [
      {
        id: 'acc-journal', label: 'Journal Entry', title: 'Jurnal Umum',
      },
      {
        id: 'acc-ledger', label: 'General Ledger', title: 'Buku Besar',
      },
      {
        id: 'acc-balance', label: 'Trial Balance', title: 'Neraca Saldo',
      },
    ],
  },
]

export const CMP_DEPT_TABS = DEPARTMENT_TABS.map(dept => ({
  id: dept.id,
  label: dept.label,
  icon: dept.icon,
  color: dept.color,
  reports: dept.reports.map(r => ({ id: r.id, label: r.label })),
}))
